import { render, staticRenderFns } from "./LightUgTableHeaderCell.vue?vue&type=template&id=1648a9e5&scoped=true"
import script from "./LightUgTableHeaderCell.vue?vue&type=script&lang=ts"
export * from "./LightUgTableHeaderCell.vue?vue&type=script&lang=ts"
import style0 from "./LightUgTableHeaderCell.vue?vue&type=style&index=0&id=1648a9e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1648a9e5",
  null
  
)

export default component.exports